import hidden from './hidden.json';
import translucent from './translucent.json';

export default { hidden, translucent };
